// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profil-account-layout select{background-color:#393f49}`, "",{"version":3,"sources":["webpack://./src/Layout/ProfileAccountLayout/ProfileAccountLayout.style.scss"],"names":[],"mappings":"AAGC,8BACC,wBAAA","sourcesContent":["@use \"../../styles/variables/color\";\n\n.profil-account-layout{\n & select {\n  background-color: color.$layout-main;\n }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
